(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("styletron-react"));
	else if(typeof define === 'function' && define.amd)
		define(["styletron-react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("styletron-react")) : factory(root["styletron-react"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition